import  { useState } from "react";
import { Table, Button } from 'antd';

import 'antd/dist/antd.min.css'
import "../../scss/report.scss"
import Loading from "../../../customer/Loading";
import axiosService from "../../../../utils/axios.service";

const RatingByKtv = (props) => {    
    const [showLoading, setShowLoading] = useState(false)
    const [pageSize, setPageSize] = useState(10)    

    const columns = [
        { 
            dataIndex: 'employee_name', 
            title: 'Nhân viên', 
            fixed:'left'
        },
        {
            dataIndex: 'total_service',
            title: 'Tổng khách hàng phục vụ',
            align: "center"
        },
        {
            dataIndex: 'total_rating',
            title: 'Tổng khách hàng rating',
            align: "center"
        },
        {
            dataIndex: 'percent_rating',
            title: 'Tỷ lệ rating',
            align: "center",
            render: (data) => { return (`${data}%`) },
            sorter: (a, b) => Number(a.percent_rating) - Number(b.percent_rating),
        },
        {
            dataIndex: 'point_average',
            title: 'Điểm trung bình',
            align: "center",
            sorter: (a, b) => a.point_average - b.point_average,
        },
        {
            dataIndex: 'rating_5',
            title: '5 sao',
            align: "center",
            render: (data) => { return (`${data} lần`) },
            sorter: (a, b) => a.rating_5 - b.rating_5,
        },
        {
            dataIndex: 'rating_4',
            title: '4 sao',
            align: "center",
            render: (data) => { return (`${data} lần`) },
            sorter: (a, b) => a.rating_4 - b.rating_4,
        },
        {
            dataIndex: 'rating_3',
            title: '3 sao',
            align: "center",
            render: (data) => { return (`${data} lần`) },
            sorter: (a, b) => a.rating_3 - b.rating_3,
        },
         {
            dataIndex: 'rating_2',
            title: '2 sao',
            align: "center",
            render: (data) => { return (`${data} lần`) },
            sorter: (a, b) => a.rating_2 - b.rating_2,
        },
        {
            dataIndex: 'rating_1',
            title: '1 sao',
            align: "center",
            render: (data) => { return (`${data} lần`) },
            sorter: (a, b) => a.rating_1 - b.rating_1,
        },
    ];

    // const handelExportData = () => {
    //     setShowLoading(true)
    //     var url = `api/reports-view/export-tracking-bhvv?storeId=${props.store}&startDate=${props.startDate}&endDate=${props.endDate}`
    //     axiosService(url, "GET")
    //     .then((res) => {
    //         if (res.data.code == 200) {
    //             window.open(res.data.data.url, '_blank');
    //             setShowLoading(false)
    //         }
    //     }).catch((error) => {
    //         console.log(error)
    //         setShowLoading(false)
    //     });
    // }

    const  handleChange = (e) => {
        setPageSize(e.pageSize)
    }
  
    return (
        <>
            <Table 
                columns={columns} 
                dataSource={props.table}
                pagination={{ pageSize: pageSize, showSizeChanger: true, pageSizeOptions: ['10', '15', '30', '50', '100'] }}
                scroll={{ x: 350 }}
                rowKey="employee_id"
                onChange={handleChange}
                bordered
            />
            <Loading show={showLoading}></Loading>
        </>
    )
}
export default RatingByKtv